export class BdtBaseModel {
    FechaCreacion: Date;
    FechaModificacion: Date;
    FechaBaja: Date;
}